import React from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import RowTable from './RowTable';
import MultiLines from './MultiLines';
import StoreImg from './StoreImg';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import useMediaQuery from '@mui/material/useMediaQuery';
import BottomButtons from './BottomButtons';
import {Theme} from './Theme';
import {Tools} from './Tools';
import {Inc,News,Owner} from './Inc';
import useStyles from './Styles';

interface Props {
    isOpen:boolean,
    news:News,
    imgs:{ [key: string]: string; },
    send():void,
    close(): void,
    owner:Owner,
}

const NewsConfirm: React.FC<Props> = (props)=> {
    const classes = useStyles();
	const fullScreen = useMediaQuery(Theme.breakpoints.down('sm'));
    //console.log( props.imgs );

    const closeModal = ()=>{
        props.close();
    }

    let photo_ids:number[] = [];
    for( let i=0 ; i<3 ; i++ ){
        if( props.news.photo_ids[i] ){
            photo_ids.push(props.news.photo_ids[i]);
        } else {
            photo_ids.push(0);
        }
    }

	return (
		<Dialog
			fullScreen={fullScreen}
			open={props.isOpen}
			aria-labelledby="alert-dialog-title"
			aria-describedby="alert-dialog-description"
			disableEscapeKeyDown={true}
			onClose={(event: object, reason: string) =>{
				if( reason!=="backdropClick" ){
					closeModal();
				}
			}}
			maxWidth='md'
		>
			<DialogTitle color='primary'>ニュース編集</DialogTitle>
			<DialogContent dividers>
				<div className={classes.confirmGuide}>
					この内容でよろしいですか？<br/>
					よろしかったら「登録する」を押して下さい。<br/>
				</div>
				<Table>
					<TableBody>
						<RowTable name="タイトル" noWrap={true} value={
							<MultiLines text={props.news.news_name}/>
						}/>
						<RowTable name="本文" value={
							<MultiLines text={props.news.news_body}/>
						}/>
						<RowTable name="画像" value={
							<React.Fragment>
							{photo_ids.map((img_id:number,index:number)=>{
								const key = "photo"+String(index+1);
								if( props.imgs[key] ){
									return (
										<span key={key} style={{marginRight:'0.25em'}}>
											<img src={props.imgs[key]} className={classes.imgProfile} alt="追加画像"/>
										</span>
									);
								} else if( props.imgs[key]==="" ){
									return (null);
								} else {
									return (
										<span key={key} style={{marginRight:'0.25em'}}>
											<StoreImg owner_id={props.owner.owner_id} img_id={img_id} className="imgProfile"/>
										</span>
									);
								}
							})}
							</React.Fragment>
						}/>
						<RowTable name="公開日" value={
							<React.Fragment>
							{props.news.news_date}
							</React.Fragment>
						}/>
						<RowTable name="終了日" value={
							<React.Fragment>
							{props.news.end_date ? (
							<span>{props.news.end_date}</span>
							):(
							<span>なし</span>
							)}
							</React.Fragment>
						}/>
						<RowTable name="状態" value={
							<React.Fragment>
							{Tools.getLabel(Inc.newsStatus,props.news.status)}
							</React.Fragment>
						}/>

					</TableBody>
				</Table>
			</DialogContent>
			<DialogActions className={classes.dialogActions}>
				<BottomButtons button1='登録する' onClick1={props.send} button2='やりなおし' onClick2={props.close} top={0} bottom={0}/>
			</DialogActions>
        </Dialog>
	);
}

export default NewsConfirm;
